
  import * as cloudflareRuntime$_1N1RG91F6I34agDIYVumBBBf92Audv9Wd8JHXwotVqs from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as ipxStaticRuntime$Vjabu2xhClCIYbt3ZN852Qq2mpPZQhhzzw4bGRijhr4 from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [
    "storage.googleapis.com"
  ],
  "alias": {
    "/lumaAssets": "https://storage.googleapis.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['cloudflare']: { provider: cloudflareRuntime$_1N1RG91F6I34agDIYVumBBBf92Audv9Wd8JHXwotVqs, defaults: {"baseURL":"https://luma-delikatessen.ch/"} },
  ['ipxStatic']: { provider: ipxStaticRuntime$Vjabu2xhClCIYbt3ZN852Qq2mpPZQhhzzw4bGRijhr4, defaults: {"isStatic":true} }
    }
  }
